import React from 'react';
import { projectConfig } from '../config/project';

const Footer: React.FC = () => {
  const projectName = projectConfig.name;

  return (
    <footer 
      className="mt-auto border-t"
      style={{
        backgroundColor: 'hsl(var(--b1))',
        borderColor: 'hsl(var(--b3))',
        color: 'hsl(var(--bc))'
      }}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 text-xs" style={{ color: 'hsl(var(--bc) / 0.7)' }}>
        <p>
          &copy; {new Date().getFullYear()} {projectName}. All rights reserved.
        </p>
        <p>Made with ❤️</p>
      </div>
    </footer>
  );
};

export default Footer;